import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import y from 'y4/Utils';
import { Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { changePassword } from 'y4/Y4Api';
import DataContext from 'y4/context/DataContext';
import { useNavigate } from 'react-router-dom';
//import { clearAuthentication } from 'y4/Authentication';
import AppContext from 'context/Context';

const PasswordResetForm = ({ hasLabel }) => {
  const { t } = useTranslation('user');
  const navigate = useNavigate();
  var cup = t('Current Password');
  var nep = t('New Password');
  var cop = t('Confirm Password');

  const { globalData } = useContext(DataContext);

  const {
    config: { team, corp }
  } = useContext(AppContext);

  // State
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    if (formData.newPassword != formData.confirmPassword) {
      y.toastWarn(t('The new password does not match the confirm password'));
    } else {
      changePassword(
        team,
        corp,
        globalData.authentication.loginType,
        globalData.authentication.user,
        formData.currentPassword,
        formData.newPassword,
        formData.confirmPassword
      ).then(rt => {
        if (rt.isOk()) {
          //clearAuthentication();
          y.toastSuccess(t('Login with your new password'), {
            theme: 'colored',
            onClose: () => {
              //window.location.href = process.env.REACT_APP_HOME + corp;
              navigate(-1);
            }
          });
        } else {
          y.toastWarn(rt.message);
        }
      });
    }
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form
      className={classNames('mt-3', { 'text-left': hasLabel })}
      onSubmit={handleSubmit}
    >
      {globalData.authentication.loginType === 'verification' ? null : (
        <Form.Group className="mb-3">
          {hasLabel && <Form.Label>{cup}</Form.Label>}
          <Form.Control
            placeholder={!hasLabel ? cup : ''}
            value={formData.currentPassword}
            name="currentPassword"
            onChange={handleFieldChange}
            type="password"
          />
        </Form.Group>
      )}
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>{nep}</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? nep : ''}
          value={formData.newPassword}
          name="newPassword"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>{cop}</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? cop : ''}
          value={formData.confirmPassword}
          name="confirmPassword"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Button
        type="submit"
        className="w-100"
        disabled={
          !(
            formData.currentPassword ||
            globalData.authentication.loginType === 'verification'
          ) ||
          !formData.newPassword ||
          !formData.confirmPassword
        }
      >
        <Trans ns="user">Set password</Trans>
      </Button>
    </Form>
  );
};

PasswordResetForm.propTypes = {
  hasLabel: PropTypes.bool
};

export default PasswordResetForm;
